import request from '@/utils/request';
import {
  endpoints,
  permissionsEndpoint,
  usersEndpoint,
  userApprovedEndpoint,
  userEndpoint,
} from '@/constants/urls';

const users = (filter, role, approvedFlag, unapprovedFlag, archivedFlag, page, pageSize, orderBy) => {
  const params = {
    filter,
    page,
    pageSize,
  };

  if (role) {
    params.role = role;
  }

  if (approvedFlag !== unapprovedFlag
      || approvedFlag !== archivedFlag) {
    if (approvedFlag) {
      params.approved = true;
    }
    if (unapprovedFlag) {
      params.unapproved = true;
    }
    if (archivedFlag) {
      params.archived = true;
    }
  }

  if (orderBy) {
    params.orderBy = orderBy;
  }

  return (
    request({
      url: endpoints.USERS,
      params,
      method: 'GET',
    })
  );
};

const user = (id) => request({
  url: userEndpoint(id),
  method: 'GET',
});

const currentUser = () => request({
  url: endpoints.SELF_USER,
  method: 'GET',
});

const guestUser = (params) => request({
  url: endpoints.GUEST_USER,
  method: 'GET',
  params,
});

const entityUsers = (
  entity,
  code,
  filter,
  assignableFlag,
) => {
  const params = {
    filter,
  };

  if (assignableFlag) {
    params.assignable = true;
    params.page = 1;
    params.pageSize = 20;
  }

  return (
    request({
      url: usersEndpoint(entity, code),
      params,
      method: 'GET',
    })
  );
};

const entityDestroy = (entity, code, uuid) => request({
  url: usersEndpoint(entity, code, uuid),
  method: 'DELETE',
});

const entityCreate = (entity, code, uuid) => request({
  url: usersEndpoint(entity, code, uuid),
  method: 'POST',
});

const entityUpdate = (entity, code, {
  uuid,
  permissions,
}) => request({
  url: usersEndpoint(entity, code, uuid),
  data: permissions,
  method: 'PUT',
});

const updateApproved = (
  uuid,
  approved,
) => request({
  url: userApprovedEndpoint(approved),
  data: {
    users: [{ uuid }],
  },
  method: 'PATCH',
});

const updateSearchable = (
  uuid,
  searchable,
) => request({
  url: userEndpoint(uuid),
  data: {
    searchable,
  },
  method: 'PATCH',
});

const entityPermissions = (entity, code) => (
  request({
    url: permissionsEndpoint(entity, code),
    method: 'GET',
  })
);

const archive = ({ id }, reason, disableTokens, archiveRequests) => {
  const data = { archived_reason: reason, archive_requests: archiveRequests, disable_tokens: disableTokens };
  return (
    request({
      url: `${userEndpoint(id)}/archive`,
      data,
      method: 'PUT',
    })
  );
};

const restore = ({ id }) => (
  request({
    url: `${userEndpoint(id)}/restore`,
    method: 'PUT',
  })
);

const UsersService = {
  users,
  user,
  currentUser,
  guestUser,
  entityPermissions,
  entityCreate,
  entityUsers,
  entityUpdate,
  entityDestroy,
  updateApproved,
  updateSearchable,
  archive,
  restore,
};

export default UsersService;
